import {
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  Grow,
  InputAdornment,
  MenuItem,
  Modal,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  styled,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material"
import { ReactComponent as ArrowDown } from "../../../../assets/icons/Arrow_down.svg"
import { ReactComponent as YellowGold } from "../../../../assets/icons/cart_icons/yellow_gold.svg"
import { ReactComponent as PinkGold } from "../../../../assets/icons/cart_icons/pink_gold.svg"
import { ReactComponent as WhiteGold } from "../../../../assets/icons/cart_icons/white_gold.svg"
import React, { useCallback, useEffect, useState } from "react"
import "./searchModal.css"
import { useGlobalContext } from "../../../../context/GlobalContext"
import NewSearchBar from "../../search/NewSeachBar"
import { getIcon } from "../../../../utils/iconConfig"
import { useItemSizes } from "../../cards/longCard/apis/itemSize"
import { useLocation } from "react-router-dom"
import apiClient from "../../../../lib/api_client"

const CustomRadioGroup = ({ label, options, value, onChange, name }) => (
  <Box marginBottom="1vw">
    <Typography className="filter-label">{label}</Typography>
    <FormControl component="fieldset">
      <RadioGroup
        row
        value={value}
        onChange={onChange}
        name={name}
        sx={{
          display: "flex",
          gap: ".75vw",
          rowGap: "0",
        }}>
        {options.map(({ label, value, icon }) => (
          <FormControlLabel
            key={value}
            value={value}
            control={
              <Radio
                sx={{
                  color: "#B0B0B0",
                  "&.Mui-checked": {
                    color: "#50C878",
                  },
                  "& .MuiSvgIcon-root": {
                    fontSize: "1.2vw", // Increase this value to make the circle bigger
                  },
                }}
              />
            }
            label={
              <Box display="flex" alignItems="center" gap={".5vw"}>
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    fontSize: ".75vw",
                    lineHeight: "100%",
                  }}>
                  {label}
                </Typography>
                {icon && <Box>{icon}</Box>}
              </Box>
            }
            className="fieldset-label"
          />
        ))}
      </RadioGroup>
    </FormControl>
  </Box>
)

const StyledButton = styled(Button)({
  backgroundColor: "#50C878",
  width: "100%",
  height: "2vw",
  padding: ".45vw 2vw",
  color: "#000000",
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: ".7vw",
  lineHeight: "100%",
  borderRadius: ".3vw",
})

const CircularCheckbox = styled(Checkbox)(({ theme }) => ({
  width: "1vw",
  height: "1vw",
  padding: ".05vw",
  borderRadius: ".3vw",
  border: ".075vw solid black",
  backgroundColor: "white",

  "& .MuiSvgIcon-root": {
    display: "none",
  },

  "&::before": {
    content: '"✓"',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    color: "transparent",
    fontSize: ".5vw",
    fontWeight: "bold",
  },
  "&.Mui-checked": {
    backgroundColor: "#50C878",
    border: ".025vw solid black",

    "&::before": {
      color: "white",
    },
  },

  "&.Mui-focusVisible": {
    outline: "none",
    boxShadow: "none",
  },
}))

const SearchModal = ({
  headLabel,
  openModal,
  handleClose,
  setRemark,
  remark,
  requestTitle,
  id,
  refetch,
}) => {
  const { setFilterModify, cartData } = useGlobalContext();
  const location = useLocation();
  const isStock = location.pathname === "/stock" || "/Stock";

  const categoriesList = [
    ...new Set(cartData?.map((item) => item?.categoryName)),
  ]

  const [selectedValues, setSelectedValues] = useState({
    diamondQuality: "",
    goldQuality: "",
    goldColor: "",
    rhodium:"",
    size: "",
    categories: [],
  })
  const [text, setText] = useState(remark)
  const [open, setOpen] = useState(false)
  const [openSize, setOpenSize] = useState(false)

  useEffect(() => {
    setText(remark)
  }, [remark, openModal])

  const submitMessage = async (id) => {
    const response = await apiClient.put(`/request/${id}`, {
      action: "cancel",
      reasonMessage: text,
    })
    refetch();
  };

  useEffect(() => {
    setSelectedValues((prevValues) => ({
      ...prevValues,
      // size: "",
    }));
  }, [selectedValues?.categories]);

  const handleChange = (event) => {
    setSelectedValues((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }))
  }

  const handleCategoryChange = (event) => {
    setSelectedValues((prev) => ({ ...prev, categories: event.target.value }))
  }

  const renderSizeValue = useCallback((selected) => {
    if (!selected || selected === "") {
      return (
        <Typography fontSize=".8vw" fontFamily="Poppins" fontWeight={700}>
          None
        </Typography>
      )
    }
    return (
      <Typography
        sx={{
          fontSize: ".8vw",
          fontWeight: 600,
          color: "#000000",
          fontFamily: "Poppins",
        }}>
        {selected}
      </Typography>
    )
  }, [])

  const MenuProps = {
    PaperProps: {
      sx: {
        maxHeight: "10vw",
        width: "12.5vw",
        marginTop: ".15vw",
        backgroundColor: "#FFFFFF",
        color: "#000000",
        borderRadius: ".25vw",
        padding: ".25vw !important",
        // ...menuStyles,
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "transparent",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "transparent",
        },
        "& .MuiList-root": {
          "& .MuiMenuItem-root": {
            fontFamily: "Karla",
            padding: ".5vw .25vw !important",
            margin: "0px 0px",
            display: "flex",
            justifyContent: "flex-start",
            alignContent: "center",
            "&:hover": {
              backgroundColor: "#444444",
              color: "#FFFFFF",
              borderRadius: ".25vw",
              margin: "0px 0px",
            },
          },
        },
      },
    },
  }

  const getGoldValue = (goldQuality, goldColor) => {
    const colorMap = {
      Yellow: "Y",
      White: "W",
      Pink: "P",
    }

    const colorCode = colorMap[goldColor]
    return colorCode ? `${goldQuality.replace("K", "")}-${colorCode}` : ""
  }

  const handleRemarkChange = (e) => {
    setText(e.target.value);
  };

  const getRhodiumValue = (rhodium) => {
    const rhodiumMap = {
      White: "W",
      Pink: "P",
      Yellow: "Y",
    }
    return rhodiumMap[rhodium] || ""
  }

  const handleSubmit = () => {
    const { diamondQuality, goldQuality, goldColor, rhodium, size, categories } =
      selectedValues

    setFilterModify({
      diamondQuality,
      goldValue: getGoldValue(goldQuality, goldColor),
      rhodium: getRhodiumValue(rhodium),
      size ,
      categories,
    })
    handleClose()
    setSelectedValues({
      diamondQuality: "",
      goldQuality: "",
      goldColor: "",
      rhodium: "",
      size: "",
      categories: [],
    })
  }

  const handlePress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault()
      handleSubmit()
    }
  }

  const { data: sizeData } = useItemSizes({
    categoryName:
      selectedValues.categories.length === 1
        ? selectedValues.categories[0]
        : "",
  })

  let content
  let searchStyle = {}
  switch (headLabel) {
    case "Search": {
      searchStyle={
        width:"auto",
        top:"15%"
      }
      content = <NewSearchBar type="home" handleClose={handleClose}/>
      break;
    }
    case "Bulk Customization": {
      searchStyle = {
        top: "20%",
        width: "28.65vw",
      }
      content = (
        <>
          <Box
            sx={{
              height: "100%",
              padding: ".1vw",
            }}>
            <Box marginBottom="1vw" onKeyDown={handlePress}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}>
                <Typography className="filter-label">Categories</Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: ".5vw",
                  }}>
                  <label
                    style={{
                      fontFamily: "Karla",
                      fontSize: ".7vw",
                      fontWeight: "700",
                      color: "#595959",
                    }}>
                    All Categories
                  </label>
                  <CircularCheckbox
                    color="success"
                    checked={
                      selectedValues?.categories?.length > 0 &&
                      categoriesList.length ===
                        selectedValues?.categories?.length
                    }
                    disableRipple
                    onChange={(event) => {
                      setSelectedValues({
                        ...selectedValues,
                        categories: event?.target?.checked
                          ? categoriesList
                          : [],
                      })
                    }}
                  />
                </Box>
              </Box>
              <Select
                fullWidth
                multiple
                value={selectedValues.categories}
                onChange={handleCategoryChange}
                displayEmpty
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                input={
                  <OutlinedInput
                    fullWidth
                    onKeyDown={handlePress}
                    endAdornment={
                      <InputAdornment position="start">
                        <Box
                          sx={{
                            transition: "transform 0.3s ease",
                            transform: open ? "rotate(180deg)" : "rotate(0deg)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            position: "absolute",
                            right: ".6vw",
                            top: "25%",
                          }}
                          onClick={(e) => {
                            e.stopPropagation()
                            setOpen(true)
                          }}>
                          <ArrowDown />
                        </Box>
                      </InputAdornment>
                    }
                  />
                }
                renderValue={(selected) =>
                  selected.length === 0 ? (
                    <Typography className="placeholder-label">
                      Choose Categories
                    </Typography>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: ".25vw",
                        maxHeight: "4vw",
                        width: "90%",
                        overflowY: "auto",
                      }}>
                      {selected.map((value) => (
                        <Chip
                          key={value}
                          label={value}
                          deleteIcon={getIcon("Cross")}
                          onDelete={() => {
                            setSelectedValues((prev) => ({
                              ...prev,
                              categories: prev.categories.filter(
                                (cat) => cat !== value
                              ),
                            }))
                          }}
                          onMouseDown={(e) => e.stopPropagation()}
                          className="modal-chip"
                        />
                      ))}
                    </Box>
                  )
                }
                MenuProps={MenuProps}
                sx={{
                  marginTop: ".6vw",
                  fontFamily: "Karla",
                  fontSize: ".9vw",
                  lineHeight: "1.1vw",
                  fontWeight: 500,
                  maxheight: "4vw",
                  borderRadius: ".25vw",
                  textTransform: "none",
                  backgroundColor: "#FFFFFF",
                  border: ".05vw solid #000000",
                  padding: "0 .25vw !important",
                  "& .MuiSelect-select": {
                    padding: ".5vw .25vw !important",
                  },
                  "& .MuiSelect-icon": {
                    display: "none",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&:focus": {
                    backgroundColor: "transparent",
                  },
                }}>
                {categoriesList.map((name) => (
                  <MenuItem
                    key={name}
                    value={name}
                    sx={{
                      fontSize: ".75vw",
                      "&.Mui-selected": {
                        backgroundColor: "#D9D9D9",
                        borderRadius: ".25vw",
                      },
                    }}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            {sizeData?.length > 0 &&
              selectedValues?.categories?.length === 1 && (
                <Box
                  sx={{
                    marginBottom: "1vw",
                    display: "flex",
                    alignItems: "center",
                    gap: ".5vw",
                  }}>
                  <Typography className="filter-label">Size</Typography>
                  <Select
                    value={selectedValues?.size}
                    onChange={handleChange}
                    displayEmpty
                    name="size"
                    open={openSize}
                    onOpen={() => setOpenSize(true)}
                    onClose={() => setOpenSize(false)}
                    input={
                      <OutlinedInput
                        endAdornment={
                          <InputAdornment position="start">
                            <Box
                              sx={{
                                transition: "transform 0.3s ease",
                                transform: openSize
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                position: "absolute",
                                right: ".6vw",
                              }}
                              onClick={(e) => {
                                e.stopPropagation()
                                setOpenSize(true)
                              }}>
                              <ArrowDown />
                            </Box>
                          </InputAdornment>
                        }
                      />
                    }
                    renderValue={renderSizeValue}
                    MenuProps={{
                      ...MenuProps,
                      PaperProps: {
                        ...MenuProps.PaperProps,
                        sx: {
                          ...MenuProps.PaperProps?.sx,
                          width: "4vw",
                        },
                      },
                    }}
                    sx={{
                      width: "6vw",
                      fontFamily: "Poppins",
                      fontSize: ".8vw",
                      fontWeight: 600,
                      height: "2vw",
                      borderRadius: ".25vw",
                      color: "#000000",
                      textTransform: "none",
                      backgroundColor: "#FFFFFF",
                      border: ".05vw solid #000000",
                      padding: "0 .25vw !important",
                      "& .MuiSelect-select": {
                        padding: ".5vw .25vw !important",
                        display: "flex",
                        alignItems: "center",
                      },
                      "& .MuiSelect-icon": {
                        display: "none",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "&:focus": {
                        backgroundColor: "transparent",
                      },
                    }}>
                    {sizeData?.map((sizeOption) => (
                      <MenuItem
                        key={sizeOption}
                        value={sizeOption}
                        sx={{
                          fontSize: ".8vw",
                          fontWeight: 600,
                          fontFamily: "Poppins",
                          padding: ".5vw 1vw",
                          "&.Mui-selected": {
                            backgroundColor: "#D9D9D9",
                            borderRadius: ".25vw",
                            height: "2vw",
                          },
                          "&:hover": {
                            backgroundColor: "#F0F0F0",
                          },
                        }}>
                        {sizeOption}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              )}

            <CustomRadioGroup
              label="Diamond Quality"
              name="diamondQuality" // Add this
              options={[
                { label: "VVS-EF", value: "VVS-EF" },
                { label: "VVS-FG", value: "VVS-FG" },
                { label: "VVS-GH", value: "VVS-GH" },
                { label: "VS-GH", value: "VS-GH" },
                { label: "VSSI-GH", value: "VSSI-GH" },
                { label: "SI-HI", value: "SI-HI" },
                { label: "SI-IJ", value: "SI-IJ" },
              ]}
              value={selectedValues.diamondQuality}
              onChange={handleChange}
            />

            <CustomRadioGroup
              label="Gold Quality"
              name="goldQuality" // Add this
              options={[
                { label: "18K", value: "18K" },
                { label: "14K", value: "14K" },
              ]}
              value={selectedValues.goldQuality}
              onChange={handleChange}
            />

            <CustomRadioGroup
              label="Gold Color"
              name="goldColor" // Add this
              options={[
                { label: "Pink", value: "Pink", icon: <PinkGold /> },
                { label: "White", value: "White", icon: <WhiteGold /> },
                { label: "Yellow", value: "Yellow", icon: <YellowGold /> },
              ]}
              value={selectedValues.goldColor}
              onChange={handleChange}
            />


             <CustomRadioGroup
              label="Rhodium"
              name="rhodium" // Add this
              options={[
                { label: "Pink", value: "Pink", icon: <PinkGold /> },
                { label: "White", value: "White", icon: <WhiteGold /> },
                { label: "Yellow", value: "Yellow", icon: <YellowGold /> },
              ]}
              value={selectedValues.rhodium}
              onChange={handleChange}
            />
          </Box>

          <StyledButton
            disabled={selectedValues.categories.length === 0}
            onClick={handleSubmit}>
            Apply
          </StyledButton>
        </>
      )
      break;
    }
    case "Message":
      {
      searchStyle = {
        top: "30%",
        width: "23vw",
      }
      content = (
        <>
          <TextareaAutosize
            minRows={5}
            value={text}
            onChange={(e) => handleRemarkChange(e)}
            placeholder="Enter your message"
            style={{
              width: "100%",
              backgroundColor: "#F3F4F6",
              borderRadius: ".4vw",
              border: "none",
              resize: "none",
              fontFamily: "Karla",
              fontWeight: 500,
              color: "#101010",
              fontSize: "1rem",
              lineHeight: "1.5",
              letterSpacing: "-0.41px",
              padding: ".6vw",
              outline: "none",
            }}
          />
          <Box display="flex" justifyContent="flex-end" mt=".8vw">
            <Button
              sx={{
                backgroundColor: `#50C878`,
                color: `#000`,
                fontFamily: "Poppins",
                fontWeight: 600,
                fontSize: ".7vw",
                cursor: "pointer",
                width: "5.25vw",
                height: "1.75vw",
                borderRadius: ".3vw",
              }}
              onClick={() => {
                handleClose();
                setRemark(text);
              }}
            >
              {"Save"}
            </Button>
          </Box>
        </>
      );
      break;
    }
    case "StockMessage":
      content = (
        <>
          <TextareaAutosize
            minRows={5}
            value={text}
            readOnly
            style={{
              width: "100%",
              backgroundColor: "#F3F4F6",
              borderRadius: ".4vw",
              border: "none",
              resize: "none",
              fontFamily: "Karla",
              fontWeight: 500,
              color: "#101010",
              fontSize: "1rem",
              lineHeight: "1.5",
              letterSpacing: "-0.41px",
              padding: ".6vw",
              outline: "none",
            }}
          />
        </>
      );
      break;
    default:
      content = (
        <>
          <TextField
            variant="standard"
            placeholder="Enter your message"
            multiline
            rows={5}
            onChange={(e) => setText(e.target.value)}
            value={text}
            fullWidth
            InputProps={{ disableUnderline: true }}
            sx={{
              backgroundColor: "#F3F4F6",
              borderRadius: ".4vw",
              "& .MuiInputBase-root": {
                fontFamily: "Karla",
                fontWeight: 500,
                color: "#101010",
                fontSize: ".9vw",
                lineHeight: "1.1vw",
                letterSpacing: "-0.41px",
                padding: ".6vw",
              },
            }}
          />
          <Box display="flex" justifyContent="flex-end" mt=".8vw">
            <Button
              sx={{
                backgroundColor: `${
                  isStock
                    ? text?.length > 0
                      ? "#E77B7B"
                      : "#4D4D4D"
                    : "#50C878"
                }`,
                color: `${
                  isStock ? (text?.length > 0 ? "#000" : "#fff") : "#000"
                }`,
                fontFamily: "Poppins",
                fontWeight: 600,
                fontSize: ".7vw",
                cursor: "pointer",
                width: "5.25vw",
                height: "1.75vw",
                borderRadius: ".3vw",
                "&.Mui-disabled": {
                  color: "#fff"
                }
              }}
              disabled={text?.length === 0}
              onClick={() => {
                handleClose()
                setRemark(text)
                if (isStock) {
                  submitMessage(id)
                }
              }}
            >
              {"Delete"}
            </Button>
          </Box>
        </>
      )
  }

  return (
    <Modal
      open={openModal}
      onClose={() => {
        handleClose()
        setSelectedValues({
          diamondQuality: "",
          goldQuality: "",
          goldColor: "",
          rhodium: "",
          size: "",
          categories: [],
        })
      }}
      sx={{ display: "flex", justifyContent: "center" }}>
      <Grow in={openModal}>
        <Box
          sx={{
            position: "absolute",
            top:searchStyle?.top||"30%",
            width: searchStyle?.width||"23vw",
            background: "white",
            borderRadius: ".6vw",
            padding: ".8vw",
            outline: "none",
            border: "none",
            width: "32vw",
          }}
          marginX="auto">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb="1.2vw">
            <Box sx={{ display: "flex", alignItems: "center", gap: ".25vw" }}>
              <Typography
                className="search-modal-title"
                marginTop={headLabel === "Bulk Customization" ? ".1vw" : ".5vw"}
              >
                {headLabel === "StockMessage" ? requestTitle : headLabel}
              </Typography>
            </Box>
            <Box
              className="modal-close"
              onClick={() => {
                handleClose()
                setSelectedValues({
                  diamondQuality: "",
                  goldQuality: "",
                  goldColor: "",
                  size: "",
                  categories: [],
                })
              }}
              sx={{ cursor: "pointer" }}>
              {getIcon("Cross")}
            </Box>
          </Box>
          {content}
        </Box>
      </Grow>
    </Modal>
  )
}

export default SearchModal
